import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import WalletHome from '../pages/WalletHome';
import WalletOffers from '../pages/WalletOffers';
import WalletProofRequests from '../pages/WalletProofRequests';
import WalletQRScanner from '../pages/WalletQRScanner';
import AuthGuard from '../guards/AuthGuard';
import FallbackPage from '../pages/FallbackPage';
import { useEffect } from 'react';
import { useCredentialData, useWebSocketContext } from '../contexts';

interface AppRouterProps {
  showWelcome: boolean;
}

const AppRouter: React.FC<AppRouterProps> = ({ showWelcome }): JSX.Element => {
  const { lastMessage } = useWebSocketContext();
  const { fetchProofs, fetchOffers, fetchAllItems } = useCredentialData();
  useEffect(() => {
    if (lastMessage?.data === 'refresh-proofs') {
      fetchProofs();
    }
    if (lastMessage?.data === 'refresh-offers') {
      fetchOffers();
    }
  }, [lastMessage, fetchProofs, fetchOffers]);

  useEffect(() => {
    fetchAllItems();
  }, [fetchAllItems]);

  return (
    <AuthGuard fallback={<FallbackPage />}>
      <Router>
        <Routes>
          <Route path="/" element={<WalletHome showWelcome={showWelcome} />} />
          <Route path="/proof-requests" element={<WalletProofRequests />} />
          <Route path="/offers" element={<WalletOffers />} />
          <Route path="/receive" element={<WalletQRScanner />} />
        </Routes>
      </Router>
    </AuthGuard>
  );
};

export default AppRouter;
